export default __webpack_public_path__ + "static/media/display-3.5c8756f1.png";